import Deposit from 'src/pages/AccountDeposit/components/Deposit';
import { ModalWrapper } from 'src/components/ModalWrapper';
import { useWindowSize } from 'react-easyrocket';
import { DepositClose } from '../svg/Crosses';
import FullScreenModalWrapper from '../FullScreenModalWrapper';
import { PropsWithChildren } from 'react';
import { useModalContext } from 'src/hooks/useModalContext';

export const DepositModal = () => {
  return (
    <Wrapper>
      <Deposit isModal />
    </Wrapper>
  );
};

function Wrapper({ children }: PropsWithChildren) {
  const { isMobileLayout } = useWindowSize();
  const { closeModal } = useModalContext();

  if (isMobileLayout) {
    return (
      <FullScreenModalWrapper>
        <DepositClose
          className="absolute top-0 right-0 cursor-pointer z-[20] box-content pt-4 px-5"
          onClick={closeModal}
        />
        {children}
      </FullScreenModalWrapper>
    );
  }

  return (
    <ModalWrapper className="768:max-w-[1000px] w-[90%] 768:min-w-[500px] px-5">
      {children}
    </ModalWrapper>
  );
}

export default DepositModal;
